<template>
    <div class="equipment-view-logs">
        <b-card no-body>
            <b-card-header>
                Logs
                <auth-template model="equipment" action="add-note">
                    <b-button class="btn-primary" @click="noteModal">
                        Add Note
                    </b-button>
                </auth-template>
            </b-card-header>
            <b-card-body>
                <b-row>
                   <b-col>
                      <h4>Equipment Logs</h4>
                       <table>
                          <tbody>
                          <tr v-for="(entry,i) in userLogs" :key="i">
                              <td>
                                  <b-badge size="sm" variant="" class="px-2 py-1 mr-2 mb-1">
                                      <timestamp :date="entry.created"/>
                                  </b-badge>
                              </td>
                              <td>
                                  {{ entry.action }}
                              </td>
                              <td>
                                  {{ entry.text }}
                              </td>
                          </tr>
                          </tbody>
                       </table>
                   </b-col>
                    <b-col>
                        <h4>Registration Logs</h4>
                        <table>
                            <tbody>
                            <tr v-for="(entry,i) in registrationLogs" :key="i">
                                <td>
                                    <b-badge size="sm" variant="" class="px-2 py-1 mr-2 mb-1">
                                        <timestamp :date="entry.created"/>
                                    </b-badge>
                                </td>
                                <td>
                                    {{ entry.text }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>

        <b-modal id="add-note-modal" title="Add Note" @ok="addNote()">
            <b-form-input type="text" v-model="note"/>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'EquipmentViewLogs',
    props: {
        equipment: Object,
    },
    data() {
        return {
            note: null
        }
    },
    computed: {
        userLogs() {
            return this.equipment.userLogs
        },
        registrationLogs() {
            return this.equipment.registrationUserLogs
        }
    },
    methods: {
        noteModal() {
            this.$bvModal.show('add-note-modal')
        },
        async addNote() {
            await this.$api.addEquipmentNote(this, this.equipment.id, this.note)
            this.note = null;
            this.$emit('noted')
        }
    }
}
</script>

<style scoped>

</style>